var map = {
  "./en.json": [
    "./src/app/translations/languages/en.json",
    "i18n-en-json"
  ],
  "./da.json": [
    "./src/app/translations/languages/da.json",
    "i18n-da-json"
  ],
  "./pl.json": [
    "./src/app/translations/languages/pl.json",
    "i18n-pl-json"
  ],
  "./sv.json": [
    "./src/app/translations/languages/sv.json",
    "i18n-sv-json"
  ],
  "./nl.json": [
    "./src/app/translations/languages/nl.json",
    "i18n-nl-json"
  ],
  "./lt.json": [
    "./src/app/translations/languages/lt.json",
    "i18n-lt-json"
  ],
  "./lv.json": [
    "./src/app/translations/languages/lv.json",
    "i18n-lv-json"
  ],
  "./nl_BE.json": [
    "./src/app/translations/languages/nl_BE.json",
    "i18n-nl_BE-json"
  ],
  "./de.json": [
    "./src/app/translations/languages/de.json",
    "i18n-de-json"
  ],
  "./es.json": [
    "./src/app/translations/languages/es.json",
    "i18n-es-json"
  ],
  "./fr.json": [
    "./src/app/translations/languages/fr.json",
    "i18n-fr-json"
  ],
  "./it.json": [
    "./src/app/translations/languages/it.json",
    "i18n-it-json"
  ],
  "./no.json": [
    "./src/app/translations/languages/no.json",
    "i18n-no-json"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "./src/app/translations/languages lazy recursive ^\\.\\/.*\\.json$";
module.exports = __rspack_async_context;
